<template>
    <div class="home">
        <Header :type="1"></Header>
        <Banner></Banner>
        <!-- 全链路产品线与服务 -->
        <ProductServices></ProductServices>
        <!-- 平台优势 -->
        <PlatformAdvantages></PlatformAdvantages>
        <!-- 行业案例 -->
        <Industry></Industry>
        <!-- 动态 -->
        <Dynamics></Dynamics>
    </div>
</template>
<script>
import Header from '../../components/header.vue'
import Banner from './banner.vue'
import ProductServices from './productServices.vue'
import PlatformAdvantages from './platformAdvantages.vue'
import Industry from './industry.vue'
import Dynamics from './dynamics.vue'
export default {
    name: "home",
    components: {
        Header,
        Banner,
        ProductServices,
        PlatformAdvantages,
        Industry,
        Dynamics
    },
    methods: {
        
    },
}
</script>



// WEBPACK FOOTER //
// src/pages/index/index.vue